// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"PopularProdSlider-module--sliderWrapper--11WW7","rowBorder":"PopularProdSlider-module--rowBorder--2Oy-8"};